import { useEffect, memo, useRef } from 'react';

let hoveredRowId;

function addHoverClass(el) {
    const rows = document.querySelectorAll('.ag-row--action-hover');
    for (let row of rows) {
        row.classList?.remove('ag-row--action-hover');
    }
    const rowsHovered = el.querySelectorAll(`[row-id='${hoveredRowId}']`);

    for (let row of rowsHovered) {
        setTimeout(() => {
            row.classList?.add('ag-row--action-hover');
        });
    }
}

function BaseReactCell({ children, data, ...props }) {
    const firstTime = useRef(true);
    useEffect(() => {
        if (!props?.context?.hasActions || !firstTime.current) return;
        firstTime.current = false;
        const node = props.node;
        const tableId = props?.context?.tableId || '';
        const elementId = tableId ? `w5-actions-component-${tableId}` : 'w5-actions-component';

        function getBodyViewPort() {
            const tableDiv = props?.context?.tableRef?.current?.eGridDiv || null;

            let bodyViewport = props.api.gridBodyCtrl.eBodyViewport;
            if (tableDiv) {
                bodyViewport = tableDiv.querySelector('.ag-body-viewport');
            }
            return bodyViewport;
        }

        const actionsWrapper = document.getElementById(elementId);

        props.eGridCell.addEventListener('mouseover', () => {
            const bodyViewport = getBodyViewPort();
            const bodyViewportContent = bodyViewport.children;
            let bodyViewportContentChild;

            for (let current of bodyViewportContent) {
                if (current.classList.contains('ag-center-cols-clipper')) {
                    bodyViewportContentChild = current;
                }
            }

            // We need to inform about that to add the correct style to prevent overlap the scroll bar.
            const hasScroll = bodyViewportContentChild.offsetHeight > bodyViewport.offsetHeight;
            props.context.getHoveredRowInfo({
                data: data,
                hasScroll,
                rowElement: props?.eGridCell?.offsetParent,
            });

            hoveredRowId = node.id;

            const scrollTop = bodyViewport.scrollTop;
            const centerElement = 40 - scrollTop;
            const actionsTop = node.rowTop + centerElement;
            if (actionsWrapper) {
                actionsWrapper.style.display = 'block';
                actionsWrapper.style.top = `${actionsTop + 3}px`;
                actionsWrapper.style.height = `${node.rowHeight - 2}px`;
                bodyViewport.onscroll = () => {
                    actionsWrapper.style.display = 'none';
                };
            }
        });

        // need all this eventListeners because some overlap the others
        // >> when I'm out from one, can be over the other, and if we don't add
        // >> this three eventListeners may cause undesired flickering in some cases
        props.eGridCell.addEventListener('mouseout', () => {
            if (actionsWrapper) {
                actionsWrapper.style.display = 'none';
            }
        });

        actionsWrapper?.addEventListener('mouseover', () => {
            if (actionsWrapper) {
                addHoverClass(getBodyViewPort());
                actionsWrapper.style.display = 'block';
            }
            props.context.possibleScrolledRow = node.id;
        });

        actionsWrapper?.addEventListener('mouseout', () => {
            if (actionsWrapper) {
                actionsWrapper.style.display = 'none';
            }
            if (props?.context?.possibleScrolledRow === node.id) {
                actionsWrapper?.scrollTo(0, 0);
                props.context.possibleScrolledRow = '';
            }
        });

        if (actionsWrapper) {
            const wheelEvent = 'onWheel' in actionsWrapper ? 'wheel' : 'mousewheel';
            actionsWrapper?.addEventListener(wheelEvent, function (event) {
                if (props?.context?.possibleScrolledRow === node.id) {
                    const bodyViewport = getBodyViewPort();
                    bodyViewport.scrollBy(event.deltaX, event.deltaY);
                    if (actionsWrapper) {
                        actionsWrapper.style.display = 'none';
                    }
                }
            });
        }
    }, [data, props]);

    return children;
}

export default memo(BaseReactCell);
